export const OUT_OF_STOCK_NOTIFICATION = 'OUT_OF_STOCK_NOTIFICATION';
export const OUT_OF_STOCK_INGREDIENT_NOTIFICATION = 'OUT_OF_STOCK_INGREDIENT_NOTIFICATION';
export const OUT_OF_STOCK_PACKAGING_NOTIFICATION = 'OUT_OF_STOCK_PACKAGING_NOTIFICATION';
export const OVERHEADS_NOTIFICATION = 'OVERHEADS_NOTIFICATION';
export const DEBTORS_NOTIFICATION = 'DEBTORS_NOTIFICATION';
